<footer class="page-footer">
  <p>© {{ currentYear }} Relias LTI 1.3 Platform. All rights reserved.</p>
</footer>
